var parent = require('../../../es/array/virtual/values');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/array/virtual/values.js
// module id = 4378
// module chunks = 25